import React, { useEffect, useState } from 'react'
import Modal from 'react-modal';
import './Penalty.css';
import { FaExclamationTriangle, FaUserPlus, FaSearch, FaInfoCircle, FaEdit, FaTrash, FaEye } from 'react-icons/fa';
import { IoMdClose } from "react-icons/io";
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';

const customStylesRes = {
    content: {
      position: 'absolute',
      border: '1px solid rgb(204, 204, 204)',
      background: 'rgb(255, 255, 255)',
      overflow: 'auto',
      borderRadius: '4px',
      outline: 'none',
      top: '60px',
      left: '50%',
      padding: '20px',
      transform: 'translate(-50%, 0%)',
      width: '100%',
      maxWidth: '85%',
      height: '100%',
      maxHeight: '90%',
    }
  }

const Penalty = () => {
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [viewModalIsOpen, setViewModalIsOpen] = useState(false);
    const [selectedPenalty, setSelectedPenalty] = useState(null);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const navigate = useNavigate();
    const token = localStorage.getItem("token");
    const [pageinationdata, setPageinationdata] = useState({
        "total": 0,
        "currentPage": 1,
        "totalPages": 0,
        "limit": 10,
        "startItem": 0,
        "endItem": 0,
        "hasNextPage": false,
        "hasPrevPage": false
    });
    
    const [formData, setFormData] = useState({
        spId: '',
        message: '',
        penlty: '',
        jobId: ''
    });

    const [penaltyList, setPenaltyList] = useState([]);
    const [serviceProviders, setServiceProviders] = useState([]);

        
    const [searchTerm, setSearchTerm] = useState("");
    const [filteredProviders, setFilteredProviders] = useState([]);
    const [selectedProviderId, setSelectedProviderId] = useState(null);
    const [searchLoading, setSearchLoading] = useState(false);
    const searchTimeoutRef = React.useRef(null);

    const getServiceProviders = async () => {
        try {
            const requestOptions = {
                method: "GET",
                redirect: "follow"
            };

            fetch("https://api.experts4u.in/api/v1/ServiceProvider/GetProviderByStatus", requestOptions)
                .then((response) => response.json())
                .then((result) => {
                    if (result.success) {
                        setServiceProviders(result.data);
                    } else {
                        console.error('Failed to fetch service providers:', result.message);
                    }
                })
                .catch((error) => {
                    console.error('Error fetching service providers:', error);
                });
        } catch (error) {
            console.error(error);
        }
    };

    const getPenalties = async () => {
        try {
          const myHeaders = new Headers();
          myHeaders.append("Content-Type", "application/json");
          myHeaders.append("Authorization", `Bearer ${token}`);
      
          const requestOptions = {
            method: "GET",
            headers: {
                "Authorization": `Bearer ${token}`
            },
            redirect: "follow"
          };
      
          fetch(`https://api.experts4u.in/api/v1/PenltySp/getAllPenltyAdmin?page=${page}&limit=${limit}`, requestOptions)
            .then((response) => response.json())
            .then((result) => {
              console.log(result)
              if (result.success) {
                setPenaltyList(result.data);
                
                let totalCount = 0;
                let totalPages = 1;
                const currentPage = page; // Use current state page
                const currentLimit = limit;

                if (result.pagination) {
                    totalCount = result.pagination.totalCount;
                    totalPages = result.pagination.totalPages;
                } else if (result.total !== undefined) {
                    // Logic for root-level pagination fields
                    totalCount = result.total;
                    totalPages = result.totalPages || Math.ceil(totalCount / currentLimit) || 1;
                } else {
                    // Fallback logic if pagination object is missing
                    if (result.totalCount !== undefined) totalCount = result.totalCount;
                    else if (result.count !== undefined) totalCount = result.count;
                    else if (result.totalDocs !== undefined) totalCount = result.totalDocs;
                    else if (result.data) totalCount = result.data.length; // Last resort fallback
                    
                    totalPages = Math.ceil(totalCount / currentLimit) || 1;
                }
                
                setPageinationdata({
                    "total": totalCount,
                    "currentPage": currentPage,
                    "totalPages": totalPages,
                    "limit": currentLimit,
                    "startItem": totalCount === 0 ? 0 : (currentPage - 1) * currentLimit + 1,
                    "endItem": Math.min(currentPage * currentLimit, totalCount),
                    "hasNextPage": currentPage < totalPages,
                    "hasPrevPage": currentPage > 1
                });
              } else {
                Swal.fire({
                  icon: 'error',
                  title: result.message,
                })
              }
            })
        } catch (error) {
          console.error(error);
        }
      }

    const openModal = () => {
        setModalIsOpen(true);
    };

    const closeModal = () => {
        setModalIsOpen(false);
    };

    const closeViewModal = () => {
        setViewModalIsOpen(false);
        // Restore body scroll when modal is closed
        document.body.style.overflow = 'unset';
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'penlty') {
            const numericValue = value.replace(/[^0-9]/g, '');
            setFormData(prevState => ({
                ...prevState,
                [name]: numericValue
            }));
        } else {
            setFormData(prevState => ({
                ...prevState,
                [name]: value
            }));
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log('Form submitted:', formData);
        
        if (selectedPenalty) {
            // Edit existing penalty
            try {
                const myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/json");
                myHeaders.append("Authorization", `Bearer ${token}`);

                const raw = JSON.stringify({
                  "penalty": formData.penlty,
                  "message": formData.message,
                });

                const requestOptions = {
                  method: "PUT",
                  headers: myHeaders,
                  body: raw,
                  redirect: "follow"
                };

                fetch(`https://api.experts4u.in/api/v2/PenltySp/editPenlty/${selectedPenalty._id}`, requestOptions)
                  .then((response) => response.json())
                  .then((result) => {
                    console.log(result)
                    if (result.success) {
                        Swal.fire({
                            icon: 'success',
                            title: result.message,
                            showConfirmButton: false,
                            timer: 1500
                        })
                        getPenalties();
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: result.message,
                            showConfirmButton: false,
                            timer: 1500
                        })
                    }
                  })
                  .catch((error) => {
                    console.error(error)
                    Swal.fire({
                        icon: 'error',
                        title: 'Something went wrong',
                        showConfirmButton: false,
                        timer: 1500
                    })
                  });
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Something went wrong',
                    showConfirmButton: false,
                    timer: 1500
                })
            }
        } else {
            // Add new penalty
            try {
                const myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/json");
                myHeaders.append("Authorization", `Bearer ${token}`);

                const createPayload = {
                  "SpId": formData.spId,
                  "message": formData.message,
                  "Penlty": formData.penlty
                };
                if (formData.jobId) {
                  createPayload["JobId"] = formData.jobId;
                }
                const raw = JSON.stringify(createPayload);

                const requestOptions = {
                  method: "POST",
                  headers: myHeaders,
                  body: raw,
                  redirect: "follow"
                };

                fetch("https://api.experts4u.in/api/v2/PenltySp/createPenltySp", requestOptions)
                  .then((response) => response.json())
                  .then((result) => {
                    console.log(result)
                    if (result.success) {
                        Swal.fire({
                            icon: 'success',
                            title: result.message,
                            showConfirmButton: false,
                            timer: 1500
                        })
                        getPenalties();
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: result.message,
                            showConfirmButton: false,
                            timer: 1500
                        })
                    }
                  })
                  .catch((error) => {
                    console.error(error)
                    Swal.fire({
                        icon: 'error',
                        title: 'Something went wrong',
                        showConfirmButton: false,
                        timer: 1500
                    })
                  });
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Something went wrong',
                    showConfirmButton: false,
                    timer: 1500
                })
            }
        }
        
        closeModal();
        setFormData({ spId: '', message: '', penlty: '', jobId: '' });
        setSelectedPenalty(null);
    };

    const handleEdit = (penalty) => {
        setSelectedPenalty(penalty);
        setFormData({
            spId: penalty.SpId?._id || '',
            message: penalty.message || '',
            penlty: penalty.Penlty || '',
            jobId: penalty.JobId || ''
        });
        openModal();
    };

    const handleDelete = (penalty) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                try {
                    const myHeaders = new Headers();
                    myHeaders.append("Authorization", `Bearer ${localStorage.getItem('token')}`);
                    myHeaders.append("Content-Type", "application/json");

                    const requestOptions = {
                      method: "DELETE",
                      headers: myHeaders,
                      redirect: "follow"
                    };

                    fetch(`https://api.experts4u.in/api/v1/PenltySp/deletePenlty/${penalty._id}`, requestOptions)
                      .then((response) => response.json())
                      .then((result) => {
                        if (result.success) {
                            Swal.fire(
                                'Deleted!',
                                result.message,
                                'success'
                            )
                            getPenalties();
                        } else {
                            Swal.fire(
                                'Error!',
                                result.message,
                                'error'
                            )
                        }
                      })
                } catch (error) {
                    console.error(error);
                    Swal.fire(
                        'Error!',
                        'Something went wrong',
                        'error'
                    )
                }
            }
        })
    };

    const handleView = (penalty) => {
        setSelectedPenalty(penalty);
        setViewModalIsOpen(true);
        // Prevent body scroll when modal is open
        document.body.style.overflow = 'hidden';
    };

    const getSelectedProviderName = (spId) => {
        const provider = serviceProviders.find(p => p._id === spId);
        return provider ? provider.Name : 'N/A';
    };

    const handlePageChange = (newPage) => {
        setPage(newPage);
    };


    const searchProviders = async (searchValue) => {
        if (!searchValue.trim()) {
            setFilteredProviders([]);
            setSearchLoading(false);
            return;
        }

        try {
            setSearchLoading(true);
            const requestOptions = {
                method: "GET",
                redirect: "follow",
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            };

            const response = await fetch(
                `https://api.experts4u.in/api/v1/PenltySp/getSpAdminSearch?search=${encodeURIComponent(searchValue)}`,
                requestOptions
            );
            const result = await response.json();
            
            console.log('Search API Response:', result);

            if (result.success) {
                console.log('Search results:', result.data);
                // Extract unique SpId objects from penalty records
                const providers = result.data
                    .map(penalty => penalty.SpId)
                    .filter(sp => sp != null); // Remove null/undefined
                
                // Remove duplicates by _id
                const uniqueProviders = providers.reduce((acc, current) => {
                    const exists = acc.find(item => item._id === current._id);
                    if (!exists) {
                        acc.push(current);
                    }
                    return acc;
                }, []);
                
                console.log('Unique providers:', uniqueProviders);
                setFilteredProviders(uniqueProviders);
            } else {
                console.error('Search failed:', result.message);
                setFilteredProviders([]);
            }
        } catch (error) {
            console.error('Error searching providers:', error);
            setFilteredProviders([]);
        } finally {
            setSearchLoading(false);
        }
    };

    const handleSearch = (e) => {
        const value = e.target.value;
        setSearchTerm(value);

        // Clear previous timeout
        if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
        }

        if (!value.trim()) {
            setFilteredProviders([]);
            setSearchLoading(false);
            return;
        }

        // Debounce search - wait 500ms after user stops typing
        setSearchLoading(true);
        searchTimeoutRef.current = setTimeout(() => {
            searchProviders(value);
        }, 500);
    };

    const handleSelect = (provider) => {
    setSearchTerm(provider.Name);
    setFilteredProviders([]);
    setSelectedProviderId(provider._id);
    };

    const handleClearFilter = () => {
        setSearchTerm("");
        setSelectedProviderId(null);
        setFilteredProviders([]);
    };



    useEffect(() => {
        console.log('Fetching penalties for page:', page, 'limit:', limit);
        getPenalties();
    }, [page, limit]);

    useEffect(() => {
        console.log('PenaltyList updated:', penaltyList.length, 'items');
        console.log('Selected Provider ID:', selectedProviderId);
    }, [penaltyList, selectedProviderId]);

    useEffect(() => {
        getServiceProviders();
    }, []);

    // Cleanup function to restore body scroll when component unmounts
    useEffect(() => {
        return () => {
            document.body.style.overflow = 'unset';
            // Cleanup search timeout
            if (searchTimeoutRef.current) {
                clearTimeout(searchTimeoutRef.current);
            }
        };
    }, []);
    
    return (
        <>
        <div className="container-fluid py-5 mt-4 penalty-section">
        <div className="row justify-content-center">
          <div className="col-md-11">
                <div className="card shadow">
                    <div className="card-header bg-gradient d-flex align-items-center justify-content-between">
                        {/* LEFT SIDE - TITLE */}
                        <h4 className="card-title mb-0 d-flex align-items-center" style={{ gap: "0.5rem" }}>
                        <span className='me-2'>
                            <FaExclamationTriangle />
                        </span>
                        Penalty Management
                        </h4>   
                        <div className="d-flex align-items-center" style={{ gap: "1rem" }}>
                            <div className="position-relative" style={{ width: "250px" }}>
                             <div className="input-group">
                                <span className="input-group-text bg-white h-100">
                                    <FaSearch />
                                </span>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Search Service Provider..."
                                    value={searchTerm}
                                    onChange={handleSearch}
                                />
                            </div>

                            {!searchLoading && filteredProviders.length > 0 && (
                                <ul
                                    className="list-group position-absolute w-100 shadow"
                                    style={{ zIndex: 1050 }}
                                >
                                    {filteredProviders.map((provider) => (
                                    <li
                                        key={provider._id}
                                        className="list-group-item list-group-item-action"
                                        onClick={() => handleSelect(provider)}
                                        style={{ cursor: "pointer" }}
                                    >
                                        {provider.Name} - {provider.ContactNo} ({provider.city})
                                    </li>
                                    ))}
                                </ul>
                                )}
                        </div>                                           
                         {/* BUTTON */}
                        {selectedProviderId && (
                            <button
                                className="btn btn-outline-danger d-flex align-items-center"
                                onClick={handleClearFilter}
                            >
                                <IoMdClose />
                                Clear
                            </button>
                        )}
                        <button
                            className="custom-button_add_penalty d-flex align-items-center" 
                            style={{ gap: "0.5rem" }}
                            onClick={openModal}
                        >
                            <span className="me-2">
                            <FaUserPlus />
                            </span>
                            Add Penalty
                        </button>
                    </div>  
                </div>

              <div className="card-body scrollbar-custom mt-2">
                <table className="table table-hover table-striped">
                    <thead className="table-info">
                        <tr>
                            <th className='text-center'>S.No</th>
                            <th className='text-center'>SP Name</th>
                            <th className='text-center'>Message</th>
                            <th className='text-center'>Penalty Amount</th>
                            <th className='text-center'>Job ID</th>
                            <th className='text-center'>Created At</th>
                            <th className='text-center'>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {(() => {
                            const filteredPenalties = penaltyList.filter(penalty => 
                                !selectedProviderId || penalty.SpId?._id === selectedProviderId
                            );
                            
                            if (filteredPenalties.length === 0) {
                                return (
                                    <tr>
                                        <td colSpan="7" className="text-center py-4">
                                            <div className="text-muted">
                                                <FaInfoCircle className="me-2" />
                                                {selectedProviderId 
                                                    ? "No penalties found for this service provider" 
                                                    : "No penalties available"}
                                            </div>
                                        </td>
                                    </tr>
                                );
                            }
                            
                            return filteredPenalties.map((penalty, index) => (
                            <tr key={penalty._id}>
                                <td className='text-center'>{index + 1}</td>
                                <td className='text-center'>{penalty.SpId?.Name || 'N/A'}</td>
                                <td className='text-center'>
                                  <div className="text-truncate" style={{maxWidth: '200px'}} title={penalty.message}>
                                    {penalty.message}
                                  </div>
                                </td>
                                <td className='text-center'>
                                  <span className="badge bg-danger p-2 px-3 rounded-pill text-white">
                                    ₹{penalty.Penlty}
                                  </span>
                                </td>
                                <td className='text-center'>
                                  <span className="badge bg-info p-2 px-3 rounded-pill text-white cursor-pointer-penalty" onClick={() =>{navigate(`/jobdetails/${penalty.JobId}`)}}>
                                    {penalty.JobId}
                                  </span>
                                </td>
                                <td className='text-center'>
                                  {new Date(penalty.createdAt).toLocaleDateString()}
                                </td>
                                <td className='text-center'>
                                    <div className="d-flex justify-content-center gap-2">
                                      <button 
                                        className="btn btn-info btn-sm" 
                                        onClick={() => handleView(penalty)}
                                        title="View"
                                      >
                                        <FaEye />
                                      </button>
                                      <button 
                                        className="btn btn-warning btn-sm" 
                                        onClick={() => handleEdit(penalty)}
                                        title="Edit"
                                      >
                                        <FaEdit />
                                      </button>
                                      <button 
                                        className="btn btn-danger btn-sm" 
                                        onClick={() => handleDelete(penalty)}
                                        title="Delete"
                                      >
                                        <FaTrash />
                                      </button>
                                    </div>
                                </td>
                            </tr>
                        ))})()}
                    </tbody>
                </table>
              </div>

              <div className="card-footer d-flex justify-content-between align-items-center pt-2 bg-light px-2 pb-2">
                <div className="d-none d-md-block">
                  <span className="text-muted">
                    Showing {pageinationdata.startItem || 0}-{pageinationdata.endItem || 0} of {pageinationdata.total || 0} penalties
                  </span>
                </div>
                <nav aria-label="Page navigation" className="mx-auto mx-md-0">
                  <ul className="pagination pagination-sm flex-wrap mb-0">
                    <li className={`page-item ${!pageinationdata.hasPrevPage ? 'disabled' : ''}`}>
                      <button 
                        className="page-link" 
                        onClick={() => handlePageChange(1)}
                        disabled={!pageinationdata.hasPrevPage}
                      >
                        <span aria-hidden="true">&laquo;&laquo;</span>
                      </button>
                    </li>
                    <li className={`page-item ${!pageinationdata.hasPrevPage ? 'disabled' : ''}`}>
                      <button 
                        className="page-link" 
                        onClick={() => handlePageChange(page - 1)}
                        disabled={!pageinationdata.hasPrevPage}
                      >
                        <span aria-hidden="true">&laquo;</span>
                      </button>
                    </li>
                    
                    {(() => {
                      const totalPages = pageinationdata.totalPages || 0;
                      const pagesPerGroup = 5;
                      let startPage = Math.max(1, page - 2);
                      let endPage = Math.min(totalPages, startPage + pagesPerGroup - 1);
                      
                      if (endPage - startPage + 1 < pagesPerGroup) {
                        startPage = Math.max(1, endPage - pagesPerGroup + 1);
                      }
                      
                      const pageNumbers = [];
                      for (let i = startPage; i <= endPage; i++) {
                        pageNumbers.push(i);
                      }
                      
                      return pageNumbers.map(pageNum => (
                        <li key={pageNum} className={`page-item ${page === pageNum ? 'active' : ''}`}>
                          <button 
                            className="page-link" 
                            onClick={() => handlePageChange(pageNum)}
                          >
                            {pageNum}
                          </button>
                        </li>
                      ));
                    })()}
                    
                    <li className={`page-item ${!pageinationdata.hasNextPage ? 'disabled' : ''}`}>
                      <button 
                        className="page-link" 
                        onClick={() => handlePageChange(page + 1)}
                        disabled={!pageinationdata.hasNextPage}
                      >
                        <span aria-hidden="true">&raquo;</span>
                      </button>
                    </li>
                    <li className={`page-item ${!pageinationdata.hasNextPage ? 'disabled' : ''}`}>
                      <button 
                        className="page-link" 
                        onClick={() => handlePageChange(pageinationdata.totalPages || 1)}
                        disabled={!pageinationdata.hasNextPage}
                      >
                        <span aria-hidden="true">&raquo;&raquo;</span>
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
        </div>

        <Modal
            isOpen={modalIsOpen}
            onRequestClose={closeModal}
            contentLabel="Add Penalty Modal"
            className="modal-dialog modal-dialog-centered"
            ariaHideApp={false}
        >
            <div className="modal-content shadow">
                <div className="modal-header bg-info text-white">
                    <h5 className="modal-title">
                      <FaExclamationTriangle className="me-2" /> 
                      {selectedPenalty ? 'Edit Penalty' : 'Add Penalty'}
                    </h5>
                    <button type="button" className="btn-close btn bg-white" onClick={closeModal}>
                      <IoMdClose />
                    </button>
                </div>
                <div className="modal-body p-4">
                    <form onSubmit={handleSubmit}>
                        {!selectedPenalty && (
                            <>
                                <div className="mb-3">
                                    <label htmlFor="spId" className="form-label fw-bold">Service Provider</label>
                                    <select 
                                        className="form-control form-control-lg" 
                                        id="spId" 
                                        name="spId"
                                        value={formData.spId}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="">Select Service Provider</option>
                                        {serviceProviders.map((provider) => (
                                            <option key={provider._id} value={provider._id}>
                                                {provider.Name} - {provider.ContactNo} ({provider.city})
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="jobId" className="form-label fw-bold">Job ID</label>
                                    <input 
                                        type="text" 
                                        className="form-control form-control-lg" 
                                        id="jobId" 
                                        name="jobId"
                                        value={formData.jobId}
                                        onChange={handleChange}
                                        placeholder="Enter job ID"
                                    />
                                </div>
                            </>
                        )}
                        {selectedPenalty && (
                            <>
                                <div className="mb-3">
                                    <label className="form-label fw-bold">Service Provider</label>
                                    <input 
                                        type="text" 
                                        className="form-control form-control-lg" 
                                        value={selectedPenalty.SpId?.Name || 'N/A'}
                                        disabled
                                        style={{backgroundColor: '#f8f9fa'}}
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label fw-bold">Job ID</label>
                                    <input 
                                        type="text" 
                                        className="form-control form-control-lg" 
                                        value={selectedPenalty.JobId || 'N/A'}
                                        disabled
                                        style={{backgroundColor: '#f8f9fa'}}
                                    />
                                </div>
                            </>
                        )}
                        <div className="mb-3">
                            <label htmlFor="message" className="form-label fw-bold">Message</label>
                            <textarea
                                className="form-control"
                                id="message"
                                name="message"
                                value={formData.message}
                                onChange={handleChange}
                                placeholder="Enter penalty message"
                                rows="3"
                            ></textarea>
                        </div>
                        <div className="mb-3">
                            <label htmlFor="penlty" className="form-label fw-bold">Penalty Amount (₹)</label>
                            <div className="input-group input-group-lg">
                                <span className="input-group-text">₹</span>
                                <input 
                                    type="number" 
                                    className="form-control form-control-lg" 
                                    id="penlty" 
                                    name="penlty"
                                    value={formData.penlty}
                                    onChange={handleChange}
                                    placeholder="Enter penalty amount"
                                    required
                                />
                            </div>
                        </div>
                        <div className="d-grid gap-2 mt-4">
                            <button type="submit" className="btn btn-info btn-lg">
                                <FaExclamationTriangle className="me-2" />
                                {selectedPenalty ? 'Update Penalty' : 'Add Penalty'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </Modal>

        {/* View Penalty Modal */}
        <Modal
            isOpen={viewModalIsOpen}
            onRequestClose={closeViewModal}
            contentLabel="View Penalty Modal"
            ariaHideApp={false}
            style={{
                content: {
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    right: 'auto',
                    bottom: 'auto',
                    marginRight: '-50%',
                    transform: 'translate(-50%, -50%)',
                    maxHeight: '90vh',
                    width: '90%',
                    maxWidth: '800px',
                    border: 'none',
                    background: 'transparent',
                    padding: '0',
                    overflow: 'hidden'
                },
                overlay: {
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    zIndex: 1000,
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0
                }
            }}
        >
            <div className="modal-content2 shadow" style={{
                background: 'white', 
                maxHeight: '90vh', 
                display: 'flex', 
                flexDirection: 'column',
                borderRadius: '8px',
                overflow: 'hidden'
            }}>
                <div className="modal-header bg-primary text-white" style={{
                    flexShrink: 0,
                    padding: '1rem',
                    borderBottom: '1px solid #dee2e6'
                }}>
                    <h5 className="modal-title mb-0">
                        <FaEye className="me-2" /> 
                        View Penalty Details
                    </h5>
                    <button type="button" className="btn-close btn bg-white" onClick={closeViewModal}>
                        <IoMdClose />
                    </button>
                </div>
                <div className="modal-body" style={{
                    overflowY: 'auto',
                    flex: 1,
                    padding: '1.5rem',
                    maxHeight: 'calc(90vh - 120px)'
                }}>
                    {selectedPenalty && (
                        <div className="row">
                            {/* Service Provider Information */}
                            <div className="col-12 mb-3">
                                <h6 className="text-primary fw-bold border-bottom pb-2">
                                    <FaUserPlus className="me-2" />
                                    Service Provider Information
                                </h6>
                            </div>
                            
                            <div className="col-md-6 mb-3">
                                <label className="form-label fw-bold text-muted">Service Provider Name</label>
                                <div className="form-control-plaintext border rounded p-2 bg-light">
                                    {selectedPenalty.SpId?.Name || 'N/A'}
                                </div>
                            </div>
                            
                            <div className="col-md-6 mb-3">
                                <label className="form-label fw-bold text-muted">Contact Number</label>
                                <div className="form-control-plaintext border rounded p-2 bg-light">
                                    {selectedPenalty.SpId?.ContactNo || 'N/A'}
                                </div>
                            </div>
                            
                            <div className="col-md-6 mb-3">
                                <label className="form-label fw-bold text-muted">Email Address</label>
                                <div className="form-control-plaintext border rounded p-2 bg-light">
                                    {selectedPenalty.SpId?.Emailid || 'N/A'}
                                </div>
                            </div>
                            
                            <div className="col-md-6 mb-3">
                                <label className="form-label fw-bold text-muted">City</label>
                                <div className="form-control-plaintext border rounded p-2 bg-light">
                                    {selectedPenalty.SpId?.city || 'N/A'}
                                </div>
                            </div>
                            
                            <div className="col-md-6 mb-3">
                                <label className="form-label fw-bold text-muted">State</label>
                                <div className="form-control-plaintext border rounded p-2 bg-light">
                                    {selectedPenalty.SpId?.State || 'N/A'}
                                </div>
                            </div>
                            
                            <div className="col-md-6 mb-3">
                                <label className="form-label fw-bold text-muted">Provider Type</label>
                                <div className="form-control-plaintext border rounded p-2 bg-light">
                                    {selectedPenalty.SpId?.Provider_Type || 'N/A'}
                                </div>
                            </div>
                            
                            <div className="col-md-6 mb-3">
                                <label className="form-label fw-bold text-muted">Gender</label>
                                <div className="form-control-plaintext border rounded p-2 bg-light">
                                    {selectedPenalty.SpId?.Gender || 'N/A'}
                                </div>
                            </div>
                            
                            <div className="col-md-6 mb-3">
                                <label className="form-label fw-bold text-muted">Date of Birth</label>
                                <div className="form-control-plaintext border rounded p-2 bg-light">
                                    {selectedPenalty.SpId?.DOB ? new Date(selectedPenalty.SpId.DOB).toLocaleDateString() : 'N/A'}
                                </div>
                            </div>
                            
                            <div className="col-md-6 mb-3">
                                <label className="form-label fw-bold text-muted">Provider Status</label>
                                <div className="form-control-plaintext border rounded p-2 bg-light">
                                    <span className={`badge ${selectedPenalty.SpId?.Status === '1' ? 'bg-success' : 'bg-danger'} text-white`}>
                                        {selectedPenalty.SpId?.Status === '1' ? 'Active' : 'Inactive'}
                                    </span>
                                </div>
                            </div>
                            
                            <div className="col-12 mb-3">
                                <label className="form-label fw-bold text-muted">Address</label>
                                <div className="form-control-plaintext border rounded p-2 bg-light">
                                    {selectedPenalty.SpId?.address || 'N/A'}
                                </div>
                            </div>
                            
                            {/* Penalty Information */}
                            <div className="col-12 mb-3">
                                <h6 className="text-danger fw-bold border-bottom pb-2">
                                    <FaExclamationTriangle className="me-2" />
                                    Penalty Information
                                </h6>
                            </div>
                            
                            <div className="col-md-6 mb-3">
                                <label className="form-label fw-bold text-muted">Job ID</label>
                                <div className="form-control-plaintext border rounded p-2 bg-light">
                                    <span className="badge bg-info text-white">{selectedPenalty.JobId || 'N/A'}</span>
                                </div>
                            </div>
                            
                            <div className="col-md-6 mb-3">
                                <label className="form-label fw-bold text-muted">Penalty Amount</label>
                                <div className="form-control-plaintext border rounded p-2 bg-light">
                                    <span className="badge bg-danger text-white fs-6">₹{selectedPenalty.Penlty || 'N/A'}</span>
                                </div>
                            </div>
                            
                            <div className="col-md-6 mb-3">
                                <label className="form-label fw-bold text-muted">Penalty Status</label>
                                <div className="form-control-plaintext border rounded p-2 bg-light">
                                    <span className={`badge ${selectedPenalty.PenltyStatus ? 'bg-success' : 'bg-warning'} text-white`}>
                                        {selectedPenalty.PenltyStatus ? 'Paid' : 'Pending'}
                                    </span>
                                </div>
                            </div>
                            
                            <div className="col-md-6 mb-3">
                                <label className="form-label fw-bold text-muted">Created Date</label>
                                <div className="form-control-plaintext border rounded p-2 bg-light">
                                    {new Date(selectedPenalty.createdAt).toLocaleDateString()}
                                </div>
                            </div>
                            
                            <div className="col-12 mb-3">
                                <label className="form-label fw-bold text-muted">Penalty Message</label>
                                <div className="form-control-plaintext border rounded p-3 bg-light" style={{minHeight: '100px', whiteSpace: 'pre-wrap'}}>
                                    {selectedPenalty.message || 'No message provided'}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                <div className="modal-footer" style={{
                    flexShrink: 0,
                    padding: '1rem',
                    borderTop: '1px solid #dee2e6',
                    backgroundColor: '#f8f9fa'
                }}>
                    <button type="button" className="btn btn-secondary" onClick={closeViewModal}>
                        Close
                    </button>
                    <button 
                        type="button" 
                        className="btn btn-warning" 
                        onClick={() => {
                            closeViewModal();
                            handleEdit(selectedPenalty);
                        }}
                    >
                        <FaEdit className="me-2" />
                        Edit Penalty
                    </button>
                </div>
            </div>
        </Modal>
        </>
    )
}

export default Penalty